<div class="section section-padding pt-0">
    <div class="container">
        <div class="section-title text-left">
            <p class="subtitle">08 --- News</p>
            <h4 class="title">Blog Insight</h4>
        </div>
        <div class="row">
            <!-- Article Start -->
            <div class="col-lg-4 col-md-6" *ngFor="let item of getRecentPost()">
                <article class="sigma_post">
                    <div class="sigma_post-thumb">
                        <a routerLink="/blog-details/{{item.id}}">
                            <img [src]="item.image[0]" [alt]="item.title">
                        </a>
                        <!-- <a class="sigma_post-category" routerLink="/blog/cat/{{cat.id}}" *ngFor="let cat of getCategories(item.category) | slice:0:1">{{cat.title}}</a> -->
                    </div>
                    <div class="sigma_post-body">
                        <h5> <a routerLink="/blog-details/{{item.id}}">{{item.title}}</a> </h5>
                        <p>{{item.shortdesc | slice:0:80}}</p>
                        <div class="sigma_post-footer">
                            <a routerLink="/blog-details/{{item.id}}">{{item.postdate}}</a>
                            <a routerLink="/blog/author/{{author.id}}" *ngFor="let author of getAuthor(item.author)">By: <b>{{author.name}}</b> </a>
                        </div>
                    </div>
                </article>
            </div>
            <!-- Article End -->
        </div>
    </div>
</div>